module.exports = require("npm:scrollparent@0.1.0/scrollparent.js");